import { Controlled as Codemirror } from 'react-codemirror2';
import styled from 'styled-components';

import { token } from '@atlaskit/tokens';

import 'codemirror/lib/codemirror.css';
import 'codemirror/addon/hint/show-hint.css';

// Code mirror addons
require('codemirror/mode/javascript/javascript');
require('codemirror/mode/yaml/yaml');
require('codemirror/addon/display/autorefresh');
require('codemirror/addon/lint/lint');
require('codemirror/addon/hint/show-hint');

const gridSize = token('space.100');

// Mostly copied from the existing pipelines codemirror instance but paired down
const StyledCodemirrorBase = styled(Codemirror)({
  // @ts-ignore
  '.CodeMirror.cm-s-default': {
    background: 'inherit',
    height: '100%',
    width: '100%',
    font: token('font.body.UNSAFE_small'),
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1.5,
    fontWeight: token('font.weight.medium'),
    fontFamily: token('font.family.code'),
    '.cm-comment': {
      color: token('color.text.subtlest'),
    },
    '.cm-string, .cm-string-2': {
      color: token('color.text.accent.orange'),
    },
    '.cm-attribute': {
      color: token('color.text.success'),
    },
    '.cm-variable': {
      color: token('color.text.accent.gray'),
    },
    '.cm-variable-2': {
      color: token('color.text.accent.blue.bolder'),
    },
    '.cm-variable-3': {
      color: token('color.text.accent.blue'),
    },
    '.cm-number': {
      color: token('color.text.accent.blue'),
    },
    '.cm-atom': {
      color: token('color.text.accent.orange'),
    },
    '.cm-qualifier': {
      color: token('color.text.accent.blue.bolder'),
    },
    '.cm-tag': {
      color: token('color.text.brand'),
    },
    '.cm-meta': {
      color: token('color.text.subtle'),
    },
    '.cm-operator': {
      color: token('color.text'),
    },
    '.cm-def, .cm-property': {
      color: token('color.text.success'),
    },
    '.cm-keyword': {
      color: token('color.text.accent.red'),
    },
    '.cm-bracket': {
      color: token('color.text'),
    },
    '.cm-type': {
      color: token('color.text.accent.blue.bolder'),
    },
    '.cm-builtin': {
      color: token('color.text.accent.blue.bolder'),
    },
    '.cm-hr': {
      color: token('color.text.accent.blue.bolder'),
    },
    '.cm-link': {
      color: token('color.link'),
    },
    '.cm-punctuation': {
      color: token('color.text'),
    },
    '.cm-quote': {
      color: token('color.text'),
    },
    '.cm-negative': {
      color: token('color.text.danger'),
    },
    '.cm-positive': {
      color: token('color.text.success'),
    },
    '.cm-invalidchar': {
      color: token('color.border.danger'),
    },
    'pre.CodeMirror-line': {
      wordBreak: 'break-all',
      color: token('color.text'),
    },
    '.CodeMirror-gutters': {
      backgroundColor: 'inherit',
      borderRight: 'none',
    },
    '.CodeMirror-linenumbers': {
      width: `calc(4px * ${gridSize})`,
      marginRight: `${gridSize}`,
    },
  },
  '.CodeMirror-cursor': {
    borderLeft: `2px solid ${token('color.background.accent.blue.subtle')}`,
  },
});

export const RemovedCodemirror = styled(StyledCodemirrorBase)({
  // @ts-ignore
  backgroundColor: token('color.background.accent.red.subtlest'),
  '.CodeMirror-linenumber::after': {
    content: "'-'",
    marginLeft: `${gridSize}`,
  },
  '.CodeMirror-selected': {
    backgroundColor: token('color.background.accent.purple.bolder'),
    opacity: 0.3,
  },
});

export const AddedCodemirror = styled(StyledCodemirrorBase)({
  // @ts-ignore
  backgroundColor: token('color.background.accent.green.subtlest'),
  '.CodeMirror-linenumber::after': {
    content: "'+'",
    marginLeft: `${gridSize}`,
  },
});
